import { validatePartnershipCode } from './validatePartnershipCode';
import { getValidateCodeByVoucher } from './validateVoucherCodeByVoucher';

/** Valid if the partnership API or the voucher API returns true. */
export async function validateManualDiscountCode(code) {
    const results = await Promise.allSettled([
        validatePartnershipCode(code),
        getValidateCodeByVoucher(code)
    ]);

    const isValid = results.some((result) => result.status === 'fulfilled' && result.value === true);
    if (isValid) return true;

    const allFailed = results.every((result) => result.status === 'rejected');
    if (allFailed) {
        throw results[0].reason;
    }

    return false;
}
